import React, { useState, useEffect } from "react";
import axios from "axios";
import { marked } from "marked";
import DOMPurify from "dompurify";
import "./Downloads.css";

function Downloads() {
  const [releases, setReleases] = useState([]);
  const [activeBuild, setActiveBuild] = useState(null);

  useEffect(() => {
    axios
      .get("/api/releases")
      .then((response) => setReleases(response.data))
      .catch((error) => console.error("Error fetching releases:", error));
  }, []);

  const toggleBuild = (buildName) => {
    setActiveBuild(activeBuild === buildName ? null : buildName);
  };

  const handleDownload = async (assetId) => {
    try {
      const response = await axios.post(`/api/releases/${assetId}/temp-link`);
      const tempLink = response.data.tempLink;
      window.location.href = tempLink;
    } catch (error) {
      console.error("Error generating download link:", error);
    }
  };

  return (
    <div className="downloads-container">
      <h1 className="downloads-title">Download Builds</h1>
      <div className="downloads-list">
        {releases.map((release) => (
          <div key={release.buildName} className="downloads-item">
            <div className="downloads-header" onClick={() => toggleBuild(release.buildName)}>
              <h2>{release.buildName}</h2>
              <span className={`arrow ${activeBuild === release.buildName ? "open" : ""}`}>&#9660;</span>
            </div>
            {activeBuild === release.buildName && (
              <div className="downloads-details">
                <p><strong>Release Date:</strong> {new Date(release.releaseDate).toLocaleDateString()}</p>
                <p><strong>Total Size:</strong> {release.totalSize}</p>

                {/* Convert markdown changelog to HTML safely */}
                <div className="changelog" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked(release.changelog)) }} />

                <div className="assets">
                  <strong>Assets:</strong>
                  <ul>
                    {release.assets?.map((asset) => (
                      <li key={asset.id}>
                        <button className="downloads-link" onClick={() => handleDownload(asset.id)}>
                          {asset.name} ({asset.size})
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Downloads;
